import React from "react";
import { Link } from "react-router-dom";
import "./WhyHaastia.css";
import Footer from "../Footer";
import { CheckIcon, XIcon } from "../public/icons";
import {
  formatSubscriptionPrice,
  getPublishedSubscriptionPlan,
} from "../../constants/subscriptionPlans";

const singlePrice = formatSubscriptionPrice(getPublishedSubscriptionPlan("single").price, "en-US");

const YES = { type: "yes" };
const NO = { type: "no" };

const columns = ["Haastia", "DMs & a paper book", "Generic scheduler", "Salon software"];

const rows = [
  {
    label: "Monthly cost",
    cells: [`${singlePrice} flat`, "Free, paid in evenings", "$15–30", "$50–200 + per chair"],
  },
  {
    label: "Deposit at booking",
    cells: [YES, "Chasing a Cash App tag", "Usually an add-on", YES],
  },
  {
    label: "Klarna / pay-in-four",
    cells: [YES, NO, NO, "Rarely"],
  },
  {
    label: "Page looks like your brand",
    cells: ["Fully editable, own domain", "It's a DM", "Logo and one colour", "Their template, their badge"],
  },
  {
    label: "Works for solo and teams",
    cells: [YES, "Hard to share", "Depends on plan", "Usually"],
  },
  {
    label: "Time to first booking",
    cells: ["An afternoon", "Immediate, forever", "A day or two", "Onboarding call first"],
  },
];

const renderCell = (cell) => {
  if (cell === YES) {
    return (
      <span className="compare-mark compare-mark--yes">
        <CheckIcon size={19} />
        <span className="sr-only">Yes</span>
      </span>
    );
  }
  if (cell === NO) {
    return (
      <span className="compare-mark compare-mark--no">
        <XIcon size={19} />
        <span className="sr-only">No</span>
      </span>
    );
  }
  return cell;
};

const WhyHaastia = () => (
  <>
    <main className="compare-page">
      <section className="site-section site-section--hero compare-hero">
        <div className="site-inner">
          <div className="site-intro">
            <p className="eyebrow">Why Haastia</p>
            <h1>You already have a booking system. It's just made of DMs.</h1>
            <p className="lead">
              Here's honestly how Haastia sits next to the three things small businesses often use
              instead.
            </p>
          </div>
        </div>
      </section>

      <section className="site-section site-section--flush-top compare-table-section">
        <div className="site-inner">
          <div className="table-scroll">
            <table className="table compare-table">
              <thead>
                <tr>
                  <th scope="col" className="compare-table__corner">
                    <span className="sr-only">Feature</span>
                  </th>
                  {columns.map((column, index) => (
                    <th
                      scope="col"
                      key={column}
                      className={index === 0 ? "compare-table__haastia" : undefined}
                    >
                      {index === 0 ? <span className="compare-table__brand">{column}</span> : column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.label}>
                    <th scope="row" className="compare-table__label">
                      {row.label}
                    </th>
                    {row.cells.map((cell, index) => (
                      <td
                        key={`${row.label}-${columns[index]}`}
                        className={index === 0 ? "compare-table__haastia" : undefined}
                      >
                        {renderCell(cell)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="site-section site-section--flush-top compare-cards-section">
        <div className="site-inner">
          <div className="compare-cards">
            <div className="panel">
              <h3>Where we're honestly weaker</h3>
              <p>
                No retail inventory, no payroll, no marketing suite. If you need stock control for
                a shelf of product, salon software wins.
              </p>
            </div>
            <div className="panel">
              <h3>Where we're better</h3>
              <p>
                Money upfront, a page you'd actually put in your bio, and a price that doesn't
                scale with how well you're doing.
              </p>
            </div>
            <div className="panel panel--surface compare-cards__cta">
              <h3>Try it against your own week</h3>
              <Link className="btn btn-primary btn-md" to="/signup">
                Start free trial
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </>
);

export default WhyHaastia;
